module.exports = __webpack_public_path__ + "static/img/8.0b063d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/8.png
// module id = EyHv
// module chunks = 0